_codeDescription.$inject = ["$http", "$parse"];
_validCp.$inject = ["$http"];
// @ts-nocheck
import { $unibase } from "../uni-base-module";
import * as _ from "lodash";
function _trim(a) {
  return $.trim(a);
}

/**
 * @name módulo directivas para validaciones
 * @description
 */
$unibase.directive("validCif", _validCif).directive("validNiss", _validNiss).directive("validDc", _validDc).directive("validNif", _validNif).directive("validCp", _validCp).directive("validPhone", _validPhone).directive("validCard", _validCard).directive("validExpirecard", _validExpirecard).directive("codeDescription", _codeDescription).directive("showOnRowHover", _showOnRowHover).directive("validHoraCuartos", _validHoraCuartos).directive("validHoraCond", _validHoraCond);
$unibase.filter("sinofilter", function () {
  return function (input, opt1, opt2) {
    return input == "S" ? "Sí" : input == "N" ? "No" : input;
  };
});
$unibase.filter("marcarTrue", ["$sce", function ($sce) {
  return function (input) {
    return input == "S" || input == true || input == "SI" ? $sce.trustAsHtml("<span class='glyphicon glyphicon-check'></span>") : "";
  };
}]);
$unibase.filter("marcarTrueFalse", ["$sce", function ($sce) {
  return function (input) {
    return input == "S" || input == "SI" || input == true ? $sce.trustAsHtml("<span class='glyphicon glyphicon-check text-primary'></span>") : $sce.trustAsHtml("<span class='glyphicon glyphicon-unchecked text-muted'></span>");
  };
}]);
$unibase.filter("formateaHTML", ["$sce", function ($sce) {
  return function (text) {
    return $sce.trustAsHtml(text);
  };
}]);
$unibase.filter("saltosLinea", ["$sce", function ($sce) {
  return function (text) {
    if (!text) {
      return "";
    }
    return $sce.trustAsHtml(text.replace(/\n/g, "<br/>"));
  };
}]);
$unibase.filter("comma2decimal", [function () {
  return function (input) {
    var ret = input ? input.toString().trim().replace(",", ".") : null;
    if (ret != null && ret > 0) {
      return parseFloat(ret);
    } else if (ret <= 0) {
      return 0;
    } else {
      return null;
    }
  };
}]);
$unibase.filter("decimal2comma", [function () {
  return function (input) {
    var ret = input ? input.toString().replace(".", ",") : null;
    if (ret) {
      var decArr = ret.split(",");
      if (decArr.length > 1) {
        var dec = decArr[1].length;
        if (dec === 1) {
          ret += "0";
        }
      } // this is to show prices like 12,20 and not 12,2
    }
    return ret;
  };
}]);
$unibase.directive("price", ["$filter", function ($filter) {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, element, attrs, ngModelController) {
      ngModelController.$parsers.push(function (data) {
        // convert data from view format to model format

        data = $filter("comma2decimal")(data);
        return data;
      });
      ngModelController.$formatters.push(function (data) {
        // convert data from model format to view format
        data = $filter("comma2decimal")(data);
        // data=$filter('decimal2comma')(data);

        return data;
      });
    }
  };
}]);
$unibase.directive("trimCharDb", ["$log", function ($log) {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, element, attrs, ngModelController) {
      $log.debug("trimCharDb ", attrs.ngModel);
      ngModelController.$formatters.push(function (data) {
        $log.debug("trim _" + data + "_");
        return data ? _.trim(data) : data;
      });
    }
  };
}]);

// -------------------- VALIDACIONES ---------------

function _validCif() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, elem, attr, ctrl) {
      ctrl.validateCif = function (a) {
        var temp = a.toUpperCase();
        var cadenadni = "TRWAGMYFPDXBNJZSQVHLCKE";
        if (temp !== "") {
          try {
            temp = _trim(temp);
          } catch (e) {}

          // si no tiene un formato valido devuelve error
          if (!/^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$/.test(temp) && !/^[T]{1}[A-Z0-9]{8}$/.test(temp) && !/^[0-9]{8}[A-Z]{1}$/.test(temp)) {
            return false; // 'El CIF no es correcto';
          }

          // comprobacion de NIFs estandar
          if (/^[0-9]{8}[A-Z]{1}$/.test(temp)) {
            var posicion = a.substring(8, 0) % 23;
            var letra = cadenadni.charAt(posicion);
            var letradni = temp.charAt(8);
            if (letra == letradni) {
              return true;
            } else {
              return false; // 'La letra del CIF no es correcta';
            }
          }

          // algoritmo para comprobacion de codigos tipo CIF
          var suma = "" + (parseInt(a.charAt(2)) + parseInt(a.charAt(4)) + parseInt(a.charAt(6), 10));
          for (var i = 1; i < 8; i += 2) {
            var temp1 = "" + 2 * parseInt(a.charAt(i), 10);
            temp1 += "";
            temp1 = temp1.substring(0, 1);
            var temp2 = "" + 2 * parseInt(a.charAt(i), 10);
            temp2 += "";
            temp2 = temp2.substring(1, 2);
            if (temp2 == "") {
              temp2 = "0";
            }
            suma += parseInt(temp1, 10) + parseInt(temp2, 10);
          }
          suma += "";
          var n = 10 - parseInt(suma.substring(suma.length - 1, suma.length), 10);

          // comprobacion de NIFs especiales (se calculan como CIFs)
          if (/^[KLM]{1}/.test(temp)) {
            if (a.charAt(8) == String.fromCharCode(64 + n)) {
              return true;
            } else {
              return false; // 'La letra del CIF no es correcta';
            }
          }
          // comprobacion de CIFs
          if (/^[ABCDEFGHJNPQRSUVW]{1}/.test(temp)) {
            temp = n + "";
            if (a.charAt(8) == String.fromCharCode(64 + n) || a.charAt(8) == parseInt(temp.substring(temp.length - 1, temp.length), 10)) {
              return true;
            } else {
              return false; // 'La letra del CIF no es correcta';
            }
          }

          // comprobacion de NIEs
          // T
          if (/^[T]{1}/.test(temp)) {
            if (a.charAt(8) == /^[T]{1}[A-Z0-9]{8}$/.test(temp)) {
              return true;
            } else {
              return false; // 'La letra del NIE no es correcta';
            }
          }

          // XYZ
          if (/^[XYZ]{1}/.test(temp)) {
            temp = temp.replace("X", "0");
            temp = temp.replace("Y", "1");
            temp = temp.replace("Z", "2");
            var pos = temp.substring(0, 8) % 23;
            if (a.charAt(8) == cadenadni.substring(pos, pos + 1)) {
              return true;
            } else {
              return false; // 'El CIF no es correcto';
            }
          }
        }
        return true;
      };
      ctrl.$parsers.unshift(function (value) {
        var valid = false;
        valid = ctrl.validateCif(value);
        ctrl.$setValidity("validCif", valid);
        return valid ? value : undefined;
      });
    }
  };
}
function _validNiss() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, elem, attr, ctrl) {
      ctrl.validateNiss = function (niss) {
        try {
          niss = _trim(niss);
        } catch (e) {}
        if (!/^[0-9]{13}$/.test(niss) && !/^[0-9]{14}$/.test(niss)) {
          return false; // 'El NISS no es correcto, debe contener 13 o 14
          // números';
        }

        // si empieza por 7777 u 9999 no validar
        if (niss.substring(0, 4) == "7777") {
          return true;
        }
        if (niss.substring(0, 4) == "9999") {
          return true;
        }
        if (niss.length < 13) {
          return false; // 'El NISS no es correcto, debe tener al menos 13
          // números';
        }
        if (niss.length == 14 && niss.substring(0, 4) == "0111") {
          return false; // 'El NISS no es correcto, tiene 14 números y no
          // comienza por 0111';
        }
        var elemCampoDC = "#" + attr.campodc;
        var dc = $(elemCampoDC).val(); // scope.empresa.dc;
        // validar el dígito de control
        if (dc != "" && dc != undefined) {
          var digcont;
          if (niss.substring(6, 7) == "0") {
            var aux_1 = niss.substring(4, 6);
            var aux_2 = niss.substring(7);
            var aux_f = aux_1 + aux_2;
            try {
              digcont = parseInt(aux_f, 10) % 97;
            } catch (error) {
              return false; // 'El NISS no es correcto*';
            }
          } else {
            var aux = niss.substring(4);
            try {
              digcont = parseInt(aux, 10) % 97;
            } catch (error) {
              return false; // 'El NISS no es correcto*';
            }
          }
          if (digcont != parseInt(dc, 10)) {
            return false;
          } // 'El NISS no es correcto, no coincide con el
          // dígito de control';

          return true;
        } else {
          return false; // 'El NISS no es correcto, no coincide con el
          // dígito de control. El dígito de control no está
          // establecido!';
        }
      };
      ctrl.$parsers.unshift(function (value) {
        var valid = false;
        valid = $("#" + attr.campodc).val() == undefined || $("#" + attr.campodc).val() == "" || ctrl.validateNiss(value);
        ctrl.$setValidity("validNiss", valid);
        return valid ? value : undefined;
      });
    }
  };
}
function _validDc() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, elem, attr, ctrl) {
      ctrl.validateDc = function (dc) {
        var niss = $("#" + attr.camponiss).val();
        if (dc != "" && dc != undefined && niss.length > 1) {
          // validar
          // el dígito
          // de
          // control

          if (niss.substring(0, 4) == "7777" || niss.substring(0, 4) == "9999") {
            return true;
          }
          var digcont;
          if (niss.substring(6, 7) == "0") {
            var aux_1 = niss.substring(4, 6);
            var aux_2 = niss.substring(7);
            var aux_f = aux_1 + aux_2;
            try {
              digcont = parseInt(aux_f, 10) % 97;
            } catch (error) {
              return false; // 'El NISS no es correcto*';
            }
          } else {
            var aux = niss.substring(4);
            try {
              digcont = parseInt(aux, 10) % 97;
            } catch (error) {
              return false; // 'El NISS no es correcto*';
            }
          }
          if (digcont != parseInt(dc, 10)) {
            return false;
          } // 'El NISS no es correcto, no coincide con
          // el
          // dígito de control';

          return true;
        } else {
          return false; // 'El NISS no es correcto, no coincide con el
          // dígito de control. El dígito de control no está
          // establecido!';
        }
      };
      ctrl.$parsers.unshift(function (value) {
        var valid = false;
        valid = $("#" + attr.camponiss).val() == undefined || $("#" + attr.camponiss).val() == "" || ctrl.validateDc(value);
        ctrl.$setValidity("validDc", valid);
        return valid ? value : undefined;
      });
    }
  };
}
function _validNif() {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link(scope, elem, attr, ctrl) {
      var validRegex = /^[XYZ]?([0-9]{7,8})([A-Z])$/i;
      var dniLetters = "TRWAGMYFPDXBNJZSQVHLCKE";
      ctrl.$parsers.unshift(function (dniTest) {
        var valid = false;
        var value = dniTest;
        try {
          value = _trim(value);
          if (value.length === 0) {
            valid = true;
          }
        } catch (e) {}
        if (value && value.length === 9) {
          value = value.toUpperCase().replace(/\s/, "");
          var niePrefix = value.charAt(0);
          switch (niePrefix) {
            case "X":
              niePrefix = 0;
              break;
            case "Y":
              niePrefix = 1;
              break;
            case "Z":
              niePrefix = 2;
              break;
          }
          value = niePrefix + value.substr(1);
          valid = false;
          if (validRegex.test(value)) {
            valid = value.charAt(8) === dniLetters.charAt(parseInt(value, 10) % 23);
          }
        }
        ctrl.$setValidity("validNif", valid);
        return valid ? dniTest : undefined;
      });
    }
  };
}
function _validCp($http) {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      // var regex = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;
      var regex = /^([1-9]|[1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;
      var validator = function validator(value) {
        var valid = false;
        if (value && value.length > 0) {
          try {
            value = _trim(value);
          } catch (e) {}
          valid = regex.test(value);
        } else {
          valid = true;
        }
        ctrl.$setValidity("validCp", valid);
        return valid ? value : undefined;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}
function _validPhone() {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      var regex = /^[9|6|7|8][0-9]{8}$/;
      var validator = function validator(value) {
        var valid = false;
        if (value && value.length > 0) {
          try {
            value = _trim(value);
          } catch (e) {}
          valid = regex.test(value);
        } else {
          valid = true;
        }
        ctrl.$setValidity("validPhone", valid);
        return value;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}
function _validCard() {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      var regex = /^((67\d{2})|(4\d{3})|(5[1-5]\d{2})|(6011))(-?\s?\d{4}){3}|(3[4,7])\ d{2}-?\s?\d{6}-?\s?\d{5}$/;
      var validator = function validator(value) {
        var valid = false;
        if (value && value.length > 0) {
          valid = regex.test(value);
        } else {
          valid = true;
        }
        ctrl.$setValidity("validCard", valid);
        return value;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}
function _validExpirecard() {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      var regex = /^(0?[1-9]|1[012])[- /.](([1][5-9])|([2][0-9]))$/;
      var validator = function validator(value) {
        var valid = false;
        if (value && value.length > 0) {
          valid = regex.test(value);
        } else {
          valid = true;
        }
        ctrl.$setValidity("validExpirecard", valid);
        return value;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}
function _codeDescription($http, $parse) {
  return function (scope, element, attrs) {
    if (attrs.ngModel && attrs.value) {
      // $parse(attrs.ngModel).assign(scope, attrs.value);
      var url = "/unimatservicios/services/fili/" + attrs.store + "/get/" + attrs.value + ".json";
      $http.get(url, {
        cache: false,
        params: {
          ts: new Date().getTime()
        }
      }).success(function (dataFromServer, status, headers, config) {
        $("#" + attrs.codeDescription).text(dataFromServer[attrs.descripcion]);
      }).error(function (data, status, headers, config) {});
    }
  };
}
function _showOnRowHover() {
  return {
    link: function link(scope, element, attrs) {
      $(element).closest("tr").bind("mouseenter", function () {
        $(element).show();
      });
      $(element).closest("tr").bind("mouseleave", function () {
        $(element).hide();
        var contextmenu = $(element).find("#contextmenu");
        contextmenu.click();
        $(element).parent().removeClass("open");
      });
    }
  };
}
function _validHoraCuartos() {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      var regex = /^[0-9]+\.(00|0|25|75|50|5)$/;
      var regex2 = /^[1-9]?[0-9]*$/;
      var validator = function validator(value) {
        var valid = false;
        if (value && value.length > 0) {
          valid = regex.test(value) || regex2.test(value);
        } else {
          valid = true;
        }
        ctrl.$setValidity("horaValidaCuartos", valid);
        return value;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}
function _validHoraCond() {
  return {
    require: "ngModel",
    link: function link(scope, elm, attrs, ctrl) {
      var requiredCond = attrs.ngRequired;
      scope.$watch(requiredCond, function (newValue, oldValue) {
        validator(ctrl.$viewValue);
      });
      var validator = function validator(value) {
        var valid = true;
        // si es requerido, controlar que sea mayor que 0
        if (scope.$eval(requiredCond)) {
          valid = value != 0;
        }
        ctrl.$setValidity("validHoraCond", valid);
        return value;
      };
      ctrl.$parsers.unshift(validator);
      ctrl.$formatters.unshift(validator);
    }
  };
}